import React, { useState, useEffect } from 'react';

import classes from "./UserIcon.module.css";

const ExtraUsersIcon = (props) => {
    return (
       <div style={{background: "lightgrey", border: "1px solid white"}} className={`${classes[props.className]} ${classes['userIcon-div']}`}>
            <h2>{props.userInitials}</h2>
        </div>
    )
}

export default ExtraUsersIcon;